<template>
    <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Lista de Sinistros Acordo</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <div>
                                </div>
                                <v-row>
                                </v-row>
                                <adm-data-table v-if="ListSinistros!=''" :headers="gridHeaders" :export-headers="headers"
                                    :filter-source-headers="filterHeaders" :filter-columns="4" :items="ListSinistros"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina" file-name="sinistros-acordos"
>
                                    <template #item-entidadesResumo="item">
                                        <div class="gp-claim-entity-summary"><strong>{{ item.garNome || '—' }}</strong><small>{{ item.imoNome || '—' }}</small></div>
                                    </template>
                                    <template #item-pedDescricao="item">
                                        <div class="gp-claim-client-summary">
                                            <strong>{{ separarCliente(item.pedDescricao).nome }}</strong>
                                            <small v-if="separarCliente(item.pedDescricao).documento">{{ separarCliente(item.pedDescricao).documento }}</small>
                                        </div>
                                    </template>
                                    <template #item-snaDtInclusao="item">
                                        <span> {{ item.snaDtInclusao !== null ? formattedDate(item.snaDtInclusao) : null }}</span>
                                    </template>
                                      <template #item-snaDtPrimeiroVencimento="item">
                                        <span> {{ item.snaDtPrimeiroVencimento !== null ? formattedDate(item.snaDtPrimeiroVencimento) : null }}</span>
                                    </template>
                                    <template #item-snaDtCancelamento="item">
                                        <span> {{ item.snaDtCancelamento !== null ? formattedDate(item.snaDtCancelamento) : null }}</span>
                                    </template>
                                    <template #item-snaValorOriginal="item">
                                        <span> {{ item.snaValorOriginal !== null ? formatarValor(item.snaValorOriginal) : null }}</span>
                                    </template>
                                     <template #item-snaValorAcordo="item">
                                        <span> {{ item.snaValorAcordo !== null ? formatarValor(item.snaValorAcordo) : null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions"><button type="button" class="gp-table-action gp-action-edit" title="Abrir acordo" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button></div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'

export default {
    name: 'ListaSinistrosAcordoView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
        },
        searchValue: '',
        MostraGrid: true,
        headers: [],
        ListSinistros:[],
        ListSinistrosGeral:[],
        itemsSelected:[],
    }),
    computed: {
        filterHeaders() {
            const camposOcultos = [
                'snaDtInclusao', 'snaValorOriginal', 'snaValorAcordo',
                'snaQtdeParcela', 'snaDtPrimeiroVencimento', 'snaDtCancelamento'
            ];
            return this.headers.filter(header => !camposOcultos.includes(header.value));
        },
        gridHeaders() {
            const resultado = []; let entidadesIncluidas = false;
            this.headers.forEach(header => {
                if (header.value === 'garNome' || header.value === 'imoNome') {
                    if (!entidadesIncluidas) { resultado.push({ text: 'Garantidora / Imobiliária', value: 'entidadesResumo', sortable: false }); entidadesIncluidas = true; }
                } else resultado.push(header);
            });
            return resultado;
        }
    },
    methods: {
        separarCliente(valor) {
            const texto = String(valor || '').trim();
            const partes = texto.split(' - ');
            if (partes.length < 2) return { nome: texto || '—', documento: '' };
            return { nome: partes.shift(), documento: partes.join(' - ') };
        },
        SelecionaSituacao(value){
            if (value > 0){          
                this.ListSinistros = this.ListSinistrosGeral.filter(x=> x.sstIdAtual == value);
            }
            else{
                this.ListSinistros = this.ListSinistrosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        EditGrid(item) {
            this.$router.push('/sinistroacordodetalhe/' + item.snaIdCript);
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Contratacao", value: "pedId", sortable: true, });
            this.headers.push({ text: "Cliente", value: "pedDescricao", sortable: true, });
            this.headers.push({ text: "Data Inicial", value: "snaDtInclusao", sortable: true, });
            if (this.User.garid == 0){
                this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            }
            if (this.User.tpeid != 3){
            this.headers.push({ text: "Imobiliaria", value: "imoNome", sortable: true, });
            }
            this.headers.push({ text: "Valor Original", value: "snaValorOriginal", sortable: true, });
            this.headers.push({ text: "Valor Acordo", value: "snaValorAcordo", sortable: true, });
            this.headers.push({ text: "Qtde Parcelas", value: "snaQtdeParcela", sortable: true, });
            this.headers.push({ text: "1º Vencimento", value: "snaDtPrimeiroVencimento", sortable: true, });
             this.headers.push({ text: "Status", value: "statusAcordo", sortable: true, });
            this.headers.push({ text: "Data Cancelamento", value: "snaDtCancelamento", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        async Get() {
              await axios.get(`/Telas/ListaSinistrosAcordo/GetDados`)
                .then(response => {
                    this.ListSinistrosGeral = response.data.sinistrosAcordo.sort(
                        (a, b) => (b.snaDtinclusao || '').localeCompare(a.snaDtinclusao || '')
                        );
                    this.ListSinistros = this.ListSinistrosGeral;
                    this.User.garid = response.data.garId;
                    this.User.tpeid = response.data.tpeId;
                
                    this.montaGrid();
                });           
          
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
.gp-claim-entity-summary{display:flex;flex-direction:column;gap:2px;line-height:1.25}.gp-claim-entity-summary strong{color:#17223b;font-size:10.5px}.gp-claim-entity-summary small{color:#718096;font-size:9.5px}
</style>
